// features/aiChat/aiChatSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type SessionType = 'visits' | 'diagnosis' | 'medical_history';

interface Message {
  sender: 'user' | 'bot';
  content: string;
}

interface AIChatState {
  sessionType: SessionType;
  initialPrompt:boolean;
  messages: Message[];
  input: string;
  loading: boolean;
  refreshAiSummary:boolean
}

const initialState: AIChatState = {
  sessionType: 'medical_history',
  initialPrompt:true,
  messages: [],
  input: '',
  loading: false,
  refreshAiSummary:false
};

const aiAssitantSlice = createSlice({
  name: 'aiChat',
  initialState,
  reducers: {
    setAiSessionType(state, action: PayloadAction<SessionType>) {
      state.sessionType = action.payload;
    },
    setAiInitialPrompt(state, action: PayloadAction<boolean>) {
      state.initialPrompt = action.payload;
    },
    setAiUserInput(state, action: PayloadAction<string>) {
      state.input = action.payload;
    },
    addToAiMessage(state, action: PayloadAction<Message>) {
      state.messages.push(action.payload);
    },
    clearAiMessages(state) {
      state.messages = [];
    },
    setAiLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    toggleAiRefresh:(state,action) =>{
      state.refreshAiSummary=!state.refreshAiSummary
    }
  },
});

export const {
  setAiSessionType,
  setAiInitialPrompt,
  setAiUserInput,
  addToAiMessage,
  clearAiMessages,
  setAiLoading,
  toggleAiRefresh
} = aiAssitantSlice.actions;

export default aiAssitantSlice.reducer;